// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Get started page*/

.startNow_card__BXfga {
  width: 100%;
  max-width: 560px;
}

.startNow_actions__tZYIE {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
}
`, "",{"version":3,"sources":["webpack://./src/app/pages/startNow.module.css"],"names":[],"mappings":"AAAA,oBAAoB;;AAEpB;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB","sourcesContent":["/* Get started page*/\n\n.card {\n  width: 100%;\n  max-width: 560px;\n}\n\n.actions {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-2);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `startNow_card__BXfga`,
	"actions": `startNow_actions__tZYIE`
};
export default ___CSS_LOADER_EXPORT___;
